<template>
  <v-menu
    v-model="showMenu"
    :position-x="x"
    :position-y="y"
    max-width="256"
    absolute
    offset-y
  >
    <v-card class="white" flat>
      <v-card-title
        class="red lighten-2 white--text font-weight-bold text-subtitle-1"
      >
        Observaciones&nbsp;
        <v-icon class="white--text"> mdi-information </v-icon>
      </v-card-title>
      <v-card-text class="text-subtitle-2 pt-4">{{ info }}</v-card-text>
    </v-card>
  </v-menu>
</template>

<script>
export default {
  props: {
    showMenu: Boolean,
    x: Number,
    y: Number,
    info: String,
  },
};
</script>

<style>
</style>